import React,{useContext, useEffect, useState, useRef, useCallback} from 'react'
import axios from 'axios'
import {Link,NavLink,useNavigate} from 'react-router-dom'
import {UserContext} from '../context/UserContext'
import {Alert,Container,Form,Button,Card,Navbar,NavDropdown,Nav,Dropdown,Modal} from 'react-bootstrap';
import logo from '../logo.png'
import person from './person.png'
import { FaHome, FaLink, FaUser,FaList,FaBasketballBall,FaFutbol} from 'react-icons/fa';

const IDLE_TIMEOUT_MS = 10 * 60 * 1000
const COUNTDOWN_START = 10

export default function DashboardNav() {
    const {userName}=useContext(UserContext)
    const {setIsAuth} = useContext(UserContext)
    const {userStatus}= useContext(UserContext)
    const {apiToken,setApiToken} = useContext(UserContext)
    const {userToken,setUserToken}= useContext(UserContext)
    const {usrPhoto,setUsrPhoto}=useContext(UserContext)
    const navigate = useNavigate()

    const [showIdleModal, setShowIdleModal] = useState(false)
    const [countdown, setCountdown] = useState(COUNTDOWN_START)
    const idleTimerRef = useRef(null)
    const countdownTimerRef = useRef(null)
    const isModalShownRef = useRef(false)

    const logout = useCallback(() => {
        clearTimeout(idleTimerRef.current)
        clearInterval(countdownTimerRef.current)
        setIsAuth(false)
        sessionStorage.setItem("isAuth",0)
        sessionStorage.removeItem('isAuth')
        sessionStorage.removeItem('userToken')
        sessionStorage.removeItem('userName')
        sessionStorage.removeItem('mngapiToken')
        sessionStorage.removeItem('ProductTitle')
        sessionStorage.removeItem('SportID')
        sessionStorage.removeItem('appCountries')
        navigate('/login')
    }, [setIsAuth, navigate])

    const resetIdleTimer = useCallback(() => {
        clearTimeout(idleTimerRef.current)
        idleTimerRef.current = setTimeout(() => {
            isModalShownRef.current = true
            setShowIdleModal(true)
            setCountdown(COUNTDOWN_START)
        }, IDLE_TIMEOUT_MS)
    }, [])

    const handleStayActive = () => {
        clearInterval(countdownTimerRef.current)
        isModalShownRef.current = false
        setShowIdleModal(false)
        setCountdown(COUNTDOWN_START)
        resetIdleTimer()
    }

    useEffect(() => {
        const events = ['mousemove','mousedown','keypress','scroll','touchstart']
        const handleActivity = () => { if (!isModalShownRef.current) resetIdleTimer() }
        events.forEach(e => window.addEventListener(e, handleActivity))
        resetIdleTimer()
        return () => {
            events.forEach(e => window.removeEventListener(e, handleActivity))
            clearTimeout(idleTimerRef.current)
        }
    }, [resetIdleTimer])

    useEffect(() => {
        if (!showIdleModal) return
        countdownTimerRef.current = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(countdownTimerRef.current)
                    logout()
                    return 0
                }
                return prev - 1
            })
        }, 1000)
        return () => clearInterval(countdownTimerRef.current)
    }, [showIdleModal, logout])

      const [dropdownOpen, setDropdownOpen] = useState(false);
    
      const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    


  return (
    <>
    <Navbar collapseOnSelect expand="lg"  sticky="top" className="navy bg-body-tertiary" bg="dark" variant="dark">

        <Navbar.Brand>
            <Link to="/dashboard"><img src={logo} style={{width:'45px', marginTop: -7,marginLeft:20}} /></Link>
            &nbsp;
            <b>{sessionStorage.getItem('ProductTitle')}</b>
                
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="me-4" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto nav-align">
            <Nav.Link href="/#/dashboard">Dashboard</Nav.Link>
            <Nav.Link href="/#/favouriteplayers">My Favourite Players</Nav.Link>
            <Nav.Link href="/#/playerslist">Players List</Nav.Link>
            <Dropdown show={dropdownOpen} onToggle={toggleDropdown} >
            <Dropdown.Toggle as={Button} variant="secondary" id="dropdown-apps" className="dropMenu">
              Apps
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="/#/lists">
                <FaList /> Players' Lists
              </Dropdown.Item>

                <Dropdown.Item href="/#/field">
                {sessionStorage.getItem("SportID")==2 ?<FaBasketballBall/> : <FaFutbol/>} Field
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>



            {/* <Nav.Link href="#link">Link</Nav.Link> */}
            {/* <NavDropdown title="User Settings" id="basic-nav-dropdown"> */}
              {/* <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item> */}
              {/* <NavDropdown.Item href="#" onClick={logout}>Logout</NavDropdown.Item>
            </NavDropdown> */}
          </Nav>

          <Nav className="ms-auto" style={{padding:20}}>
          <Dropdown>
            <Dropdown.Toggle as={Navbar.Brand} id="dropdown-custom-components">
              <img
                // src={`${usrPhoto}`}
                src={sessionStorage.getItem('usrPhoto')}
                width="40"
                height="40"
                className="d-inline-block align-top"
                alt="Brand logo"
                style={{borderRadius:'50%'}}
              />

            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              {/* <Dropdown.Item><b>{sessionStorage.getItem('userName')}</b></Dropdown.Item>
              <Dropdown.Divider /> */}
              <Dropdown.Item href="/#/profile">My Profile</Dropdown.Item>
              {/* <Dropdown.Item href="/#/billings">Billings</Dropdown.Item> */}
              <Dropdown.Divider />
              <Dropdown.Item href="#" onClick={logout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          </Nav>          
        </Navbar.Collapse>

    </Navbar>

    <Modal show={showIdleModal} backdrop="static" keyboard={false} centered>
        <Modal.Header>
            <Modal.Title>Session Timeout</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
            <p>You have been inactive for 10 minutes.</p>
            <p>You will be logged out in</p>
            <h1 style={{fontSize:'4rem', fontWeight:'bold', color: countdown <= 5 ? '#dc3545' : '#212529'}}>{countdown}</h1>
            <p>seconds</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <Button variant="primary" size="lg" onClick={handleStayActive}>
                Stay Logged In
            </Button>
        </Modal.Footer>
    </Modal>
    </>
  )
}
